interface MembershipTableProps {
    el: HTMLElement;
}

const MembershipTable = ({ el }: MembershipTableProps): void => {
    el.addEventListener('scroll', () => {
        const left = el.scrollLeft;

        if (left > 0) {
            el.classList.add('scrolled');
        } else {
            el.classList.remove('scrolled');
        }
    });
};
export default MembershipTable;
